import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageData } from './data';
export function LookInside() {
  const {
    lookInside
  } = pageData;
  const slides = lookInside.previewImages;
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = (dir: number) => {
    setDirection(dir);
    setIndex(prev => (prev + dir + slides.length) % slides.length);
  };
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  return <section className="py-16 md:py-24 px-4 relative" data-id="element-117">
      <div className="max-w-3xl mx-auto text-center" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 md:mb-14" data-id="element-119">
          <div className="w-12 h-12 bg-navy-800 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-120">
            <span className="text-2xl" data-id="element-121">👀</span>
          </div>
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-122">{lookInside.heading}</h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-123">
            {lookInside.description}
          </p>
        </motion.div>

        {/* Carousel */}
        <div className="relative" data-id="element-124">
          <div className="relative mx-auto w-full max-w-sm overflow-hidden rounded-2xl" data-id="element-125">
            <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-126">
              <motion.img key={index} src={slides[index].src} alt={slides[index].alt} loading="lazy" drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.18} onDragEnd={(_, info) => {
              if (info.offset.x < -60) paginate(1);else if (info.offset.x > 60) paginate(-1);
            }} custom={direction} initial={(d: number) => ({
              opacity: 0,
              x: d > 0 ? 80 : -80
            })} animate={{
              opacity: 1,
              x: 0
            }} exit={(d: number) => ({
              opacity: 0,
              x: d > 0 ? -80 : 80
            })} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="w-full h-auto block rounded-2xl border border-slate-200 bg-white shadow-2xl ring-1 ring-black/5 cursor-grab active:cursor-grabbing select-none" data-id="element-127" />
            </AnimatePresence>
          </div>

          {/* Arrows */}
          <button type="button" onClick={() => paginate(-1)} aria-label="Previous page" className="absolute top-1/2 -translate-y-1/2 left-0 md:-left-4 w-11 h-11 rounded-full bg-navy-800 border border-slate-700 text-white flex items-center justify-center shadow-lg hover:bg-gold-500 hover:text-navy-950 transition-colors" data-id="element-128">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-129" />
          </button>
          <button type="button" onClick={() => paginate(1)} aria-label="Next page" className="absolute top-1/2 -translate-y-1/2 right-0 md:-right-4 w-11 h-11 rounded-full bg-navy-800 border border-slate-700 text-white flex items-center justify-center shadow-lg hover:bg-gold-500 hover:text-navy-950 transition-colors" data-id="element-130">
            <ChevronRightIcon className="w-6 h-6" data-id="element-131" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-132">
          {slides.map((_, i) => <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-all duration-300 ${i === index ? 'w-6 bg-gold-500' : 'w-2 bg-slate-700 hover:bg-slate-500'}`} data-id="element-133" />)}
        </div>

        <p className="text-sm text-slate-500 mt-6 font-medium" data-id="element-134">
          {lookInside.previewCaption}
        </p>
      </div>
    </section>;
}